module.exports = __webpack_public_path__ + "static/media/limpiar-filtros.dd19cf66.svg";